(function () {
  var STORAGE_KEY = 'pkWishlistItemsV1';
  var WEBHOOK = 'https://hooks.zapier.com/hooks/catch/6329132/u6we866/';
  var pulseTimer = null;
  var HEART_ICON = 'heart';
  var HEART_ACTIVE_COLOR = '#bf81f5';
  var HEART_INACTIVE_COLOR = '#bf81f5';
  var FONT_AWESOME_HREF = 'https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css';
  var SHOP_DOMAIN_PATTERN = /^(https?:)?\/\/(www\.)?purebredkitties\.com(?=\/|$)/i;
  var DETAILS_VIEW_SUFFIX = 'recomended_view';
  var wishlistDetailsCache = {};
  var REMOVE_BUTTON_ICON = "<svg width='34' height='35' viewBox='0 0 34 35' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16.7588' cy='17.5598' r='16.124' fill='white' stroke='#774C9D'/><path d='M18.6159 15.5432C18.8617 15.5432 19.0973 15.6408 19.2711 15.8146C19.4448 15.9883 19.5424 16.224 19.5424 16.4697V21.7198C19.5424 21.9655 19.4448 22.2012 19.2711 22.3749C19.0973 22.5487 18.8617 22.6463 18.6159 22.6463C18.3702 22.6463 18.1346 22.5487 17.9608 22.3749C17.7871 22.2012 17.6895 21.9655 17.6895 21.7198V16.4697C17.6895 16.224 17.7871 15.9883 17.9608 15.8146C18.1346 15.6408 18.3702 15.5432 18.6159 15.5432Z' fill='#774C9D'/><path d='M15.8315 16.4697C15.8315 16.224 15.7339 15.9883 15.5601 15.8146C15.3864 15.6408 15.1507 15.5432 14.905 15.5432C14.6593 15.5432 14.4236 15.6408 14.2499 15.8146C14.0761 15.9883 13.9785 16.224 13.9785 16.4697V21.7198C13.9785 21.9655 14.0761 22.2012 14.2499 22.3749C14.4236 22.5487 14.6593 22.6463 14.905 22.6463C15.1507 22.6463 15.3864 22.5487 15.5601 22.3749C15.7339 22.2012 15.8315 21.9655 15.8315 21.7198V16.4697Z' fill='#774C9D'/><path fill-rule='evenodd' clip-rule='evenodd' d='M13.361 11.8373C13.361 10.9363 13.7189 10.0723 14.356 9.43518C14.993 8.7981 15.8571 8.44019 16.7581 8.44019C17.6591 8.44019 18.5231 8.7981 19.1602 9.43518C19.7973 10.0723 20.1552 10.9363 20.1552 11.8373H23.8612C24.1069 11.8373 24.3426 11.9349 24.5163 12.1087C24.6901 12.2824 24.7877 12.5181 24.7877 12.7638C24.7877 13.0095 24.6901 13.2452 24.5163 13.4189C24.3426 13.5927 24.1069 13.6903 23.8612 13.6903H22.9347V20.4228C22.9347 22.4981 22.9347 23.5358 22.5308 24.3289C22.1755 25.0262 21.6085 25.5931 20.9112 25.9484C20.1182 26.3523 19.0805 26.3523 17.0052 26.3523H16.511C14.4357 26.3523 13.398 26.3523 12.605 25.9484C11.9077 25.5931 11.3407 25.0262 10.9854 24.3289C10.5815 23.5358 10.5815 22.4981 10.5815 20.4228V13.6903H9.65501C9.40929 13.6903 9.17363 13.5927 8.99988 13.4189C8.82613 13.2452 8.72852 13.0095 8.72852 12.7638C8.72852 12.5181 8.82613 12.2824 8.99988 12.1087C9.17363 11.9349 9.40929 11.8373 9.65501 11.8373H13.361ZM15.2139 11.8373C15.2139 11.4278 15.3766 11.035 15.6662 10.7454C15.9558 10.4559 16.3486 10.2932 16.7581 10.2932C17.1676 10.2932 17.5604 10.4559 17.85 10.7454C18.1396 11.035 18.3022 11.4278 18.3022 11.8373H15.2139ZM12.4345 13.6903H21.0817V20.4228C21.0817 21.4913 21.0805 22.1807 21.0372 22.7057C20.9965 23.2097 20.9261 23.3962 20.8791 23.4876C20.7015 23.8359 20.4183 24.1192 20.07 24.2968C19.9786 24.3437 19.792 24.4141 19.288 24.4549C18.763 24.4981 18.0737 24.4993 17.0052 24.4993H16.511C15.4425 24.4993 14.7532 24.4981 14.2282 24.4549C13.7242 24.4141 13.5376 24.3437 13.4462 24.2968C13.0974 24.1194 12.8137 23.8361 12.6358 23.4876C12.5901 23.3962 12.5197 23.2097 12.4789 22.7057C12.4357 22.1807 12.4345 21.4913 12.4345 20.4228V13.6903Z' fill='#774C9D'/></svg>";

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getItems() {
    var parsed = safeParse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(parsed) ? parsed : [];
  }

  function setItems(items, previousCount) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    renderLegacyHearts();
    syncButtons();
    renderWishlistPage();
    updateCounters(typeof previousCount === 'number' ? previousCount : items.length);
  }

  function getPreviewThemeId() {
    try {
      var fromUrl = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (fromUrl) {
        return fromUrl;
      }
    } catch (error) {
    }

    var previewFrame = document.querySelector('iframe[src*="preview_theme_id="]');
    if (previewFrame) {
      try {
        return new URL(previewFrame.getAttribute('src'), window.location.origin).searchParams.get('preview_theme_id') || '';
      } catch (error) {
      }
    }

    var previewLink = document.querySelector('a[href*="preview_theme_id="]');
    if (previewLink) {
      try {
        return new URL(previewLink.getAttribute('href'), window.location.origin).searchParams.get('preview_theme_id') || '';
      } catch (error) {
      }
    }

    return '';
  }

  function isPreviewSession() {
    return !!getPreviewThemeId();
  }

  function rewritePreviewHref(url) {
    if (!url || !isPreviewSession()) {
      return url;
    }

    try {
      var isAbsoluteShopUrl = SHOP_DOMAIN_PATTERN.test(url);
      var isRelativeShopUrl = url.charAt(0) === '/';

      if (!isAbsoluteShopUrl && !isRelativeShopUrl) {
        return url;
      }

      var targetUrl = new URL(url, window.location.origin);
      var previewUrl = new URL(targetUrl.pathname + targetUrl.search + targetUrl.hash, window.location.origin);
      previewUrl.searchParams.set('preview_theme_id', getPreviewThemeId());
      return isRelativeShopUrl
        ? previewUrl.pathname + previewUrl.search + previewUrl.hash
        : previewUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function syncPreviewOriginLinks(root) {
    if (!isPreviewSession()) return;

    (root || document).querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (!SHOP_DOMAIN_PATTERN.test(href)) return;

      var rewrittenHref = rewritePreviewHref(href);
      if (rewrittenHref && rewrittenHref !== href) {
        link.setAttribute('href', rewrittenHref);
      }
    });
  }

  function normalizeItem(raw) {
    if (!raw) return null;

    var productId = String(raw.productId || raw.id || '').trim();
    var handle = String(raw.handle || '').trim();
    var url = String(raw.url || '').trim();

    if (!productId || !handle || !url) {
      return null;
    }

    return {
      productId: productId,
      handle: handle,
      url: rewritePreviewHref(url),
      title: String(raw.title || '').trim(),
      breed: String(raw.breed || '').trim(),
      image: String(raw.image || '').trim(),
      variantId: String(raw.variantId || '').trim(),
      variantName: String(raw.variantName || '').trim(),
      price: String(raw.price || '').trim(),
      priceFormatted: String(raw.priceFormatted || '').trim(),
      cardHtml: ''
    };
  }

  function findIndex(productId) {
    var items = getItems();
    for (var i = 0; i < items.length; i += 1) {
      if (String(items[i].productId) === String(productId)) {
        return i;
      }
    }
    return -1;
  }

  function hasItem(productId) {
    return findIndex(productId) !== -1;
  }

  function getItemById(productId) {
    var items = getItems();
    for (var i = 0; i < items.length; i += 1) {
      if (String(items[i].productId) === String(productId)) {
        return items[i];
      }
    }
    return null;
  }

  function addItem(item) {
    var normalized = normalizeItem(item);
    if (!normalized) return null;

    var items = getItems();
    var previousCount = items.length;
    var existingIndex = findIndex(normalized.productId);

    if (existingIndex !== -1) {
      items[existingIndex] = normalized;
    } else {
      items.unshift(normalized);
      sendWishlistWebhook(normalized);
    }

    setItems(items, previousCount);
    return normalized;
  }

  function removeItem(productId) {
    var items = getItems();
    var previousCount = items.length;
    var nextItems = items.filter(function (item) {
      return String(item.productId) !== String(productId);
    });

    setItems(nextItems, previousCount);
  }

  function toggleItem(item) {
    if (!item || !item.productId) return false;

    if (hasItem(item.productId)) {
      removeItem(item.productId);
      return false;
    }

    addItem(item);
    return true;
  }

  function getProductData(source) {
    if (!source) return null;

    var dataset = source.dataset || {};
    var marker = source.closest('.zoomywishid, .wishlist-section, .wishlist_w, .thub_box, .product_outer, .product-grid-item, .product-item, article, li, div');
    var meta = marker && marker.classList.contains('zoomywishid') ? marker : marker ? marker.querySelector('.zoomywishid') : null;
    var metaDataset = meta ? meta.dataset : {};

    return normalizeItem({
      productId: dataset.productId || metaDataset.productId,
      handle: dataset.handle || metaDataset.handle,
      url: dataset.url || metaDataset.url,
      title: dataset.title || metaDataset.title,
      breed: dataset.breed || metaDataset.breed,
      image: dataset.image || metaDataset.image,
      variantId: dataset.variantId || metaDataset.variant,
      variantName: dataset.variantName || metaDataset.variantname,
      price: dataset.price || metaDataset.price,
      priceFormatted: dataset.priceFormatted || metaDataset.priceFormatted
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function injectRemoveButton(cardHtml, productId) {
    if (!cardHtml) return '';

    var removeButton = "<button class='wishlist-card-remove' aria-label='Remove from wishlist' value='" + productId + "' data-pk-wishlist-remove='" + productId + "'>" + REMOVE_BUTTON_ICON + "</button>";
    return cardHtml.replace(
      '<div class=\"product-grid-item__image\" data-product-media-container>',
      '<div class=\"product-grid-item__image\" data-product-media-container>' + removeButton
    );
  }

  function getDetailsUrl(item) {
    if (!item || !item.handle) return '';
    var baseUrl = rewritePreviewHref('/products/' + item.handle);
    return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'view=' + DETAILS_VIEW_SUFFIX;
  }

  function fetchWishlistDetails(item) {
    if (!item || !item.handle) {
      return Promise.resolve(null);
    }

    if (wishlistDetailsCache[item.handle]) {
      return Promise.resolve(wishlistDetailsCache[item.handle]);
    }

    return fetch(getDetailsUrl(item), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Wishlist card details request failed');
        }
        return response.text();
      })
      .then(function (html) {
        if (!html || html.indexOf('product-grid-item') === -1) {
          throw new Error('Wishlist card details payload is invalid');
        }

        var details = {
          title: item.title,
          card_html: injectRemoveButton(html, item.productId)
        };

        wishlistDetailsCache[item.handle] = details;
        return details;
      });
  }

  function ensureFontAwesome() {
    if (document.querySelector('link[data-pk-wishlist-font-awesome]')) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONT_AWESOME_HREF;
    link.setAttribute('data-pk-wishlist-font-awesome', 'true');
    document.head.appendChild(link);
  }

  function ensureLegacyClasses() {
    document.documentElement.classList.add('swym-ready');
    if (document.body) {
      document.body.classList.add('swym-ready');
      if (document.getElementById('ZoomyWishlistPage')) {
        document.body.classList.add('body-wishlist');
      }
    }
  }

  function buildLegacyHeart(productId, active) {
    var heartClass = active ? 'fa-' + HEART_ICON : 'fa-' + HEART_ICON + '-o';
    var stateClass = active ? 'zadbg' : 'zrmvbg';
    var checked = active ? " checked='true'" : '';
    var color = active ? HEART_ACTIVE_COLOR : HEART_INACTIVE_COLOR;

    return "<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" + productId + "' class='zoomycheck checkbox-" + productId + "' id='checkbox-" + productId + "'" + checked + "/><label for='checkbox-" + productId + "'><p class='zooomywishmsg " + stateClass + " zooomywishmsg-" + productId + "' style='cursor:pointer;'><i class='fa " + heartClass + "' style='color: " + color + ";' aria-hidden='true'></i></p></label></div>";
  }

  function renderLegacyHearts(root) {
    var scope = root || document;
    scope.querySelectorAll('.zoomywishid').forEach(function (node) {
      var productId = node.dataset.productId;
      if (!productId) return;
      if (node.closest('.wishlist_w')) return;
      node.innerHTML = buildLegacyHeart(productId, hasItem(productId));
    });
  }

  function syncButton(button) {
    if (!button) return;

    var productId = button.dataset.productId;
    var active = productId ? hasItem(productId) : false;

    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    button.classList.toggle('is-active', active);
    button.dataset.inWishlist = active ? 'true' : 'false';
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-pk-wishlist-button]').forEach(syncButton);
  }

  function updateCounters(previousCount) {
    var count = getItems().length;

    document.querySelectorAll('#wishCount, #wishlist-counter, [data-wishlist-count], #zooomy-wishlist-counter').forEach(function (node) {
      node.textContent = count;
      node.innerHTML = '<span>' + count + '</span>';
    });

    if (count !== previousCount) {
      pulseFloatingHeart();
    }

    window.dispatchEvent(new CustomEvent('pk:wishlist:updated', {
      detail: {
        count: count,
        previousCount: previousCount
      }
    }));
  }

  function pulseFloatingHeart() {
    var heart = document.querySelector('.scroll-up-button.heart-scroll svg');
    if (!heart) return;

    if (pulseTimer) {
      clearTimeout(pulseTimer);
    }

    heart.classList.add('wishlist-pulse');
    pulseTimer = setTimeout(function () {
      heart.classList.remove('wishlist-pulse');
      pulseTimer = null;
    }, 5000);
  }

  function buildWishlistPage(items) {
    return items.map(function (item) {
      var details = item && item.details ? item.details : null;
      var cardHtml = details.card_html;
      var productId = escapeHtml(item.productId);

      return cardHtml.replace(
        "class='product-grid-item",
        "id='ZoomyWishlistPageGrid-" + productId + "' class='product-grid-item"
      );
    }).join('');
  }

  function renderWishlistPage() {
    var container = document.getElementById('ZoomyWishlistPage') || document.querySelector('[data-pk-wishlist-page]');
    if (!container) return;

    var items = getItems();

    if (!items.length) {
      container.innerHTML = "<div class='zwishemptymsg'><p class='zmsg'>Your wishlist is empty</p></div>";
      return;
    }

    container.innerHTML = "<div class='zwishemptymsg'><p class='zmsg'>Loading wishlist...</p></div>";

    Promise.all(items.map(function (item) {
      return fetchWishlistDetails(item).then(function (details) {
        return Object.assign({}, item, { details: details });
      });
    }))
      .then(function (itemsWithDetails) {
        container.innerHTML = "<div class='grid'>" + buildWishlistPage(itemsWithDetails) + "</div>";
      })
      .catch(function (error) {
        console.error(error);
        container.innerHTML = "<div class='zwishemptymsg'><p class='zmsg'>Wishlist failed to load</p></div>";
      });
  }

  function getCustomerData() {
    if (window.Customer && window.Customer.email) {
      return {
        name: [window.Customer.first_name, window.Customer.last_name].filter(Boolean).join(' ') || 'Unknown',
        email: window.Customer.email
      };
    }

    var cached = safeParse(localStorage.getItem('customer_data'));
    if (cached) {
      return {
        name: cached.name || 'Unknown',
        email: cached.email || 'Unknown'
      };
    }

    return {
      name: 'Unknown',
      email: 'Unknown'
    };
  }

  function sendWishlistWebhook(item) {
    var payload = {
      event: 'product_added_to_wishlist',
      timestamp: new Date().toISOString(),
      customer: getCustomerData(),
      product: {
        id: item.productId,
        name: item.title || 'Unknown',
        category: item.breed || 'Unknown',
        breed: item.breed || 'Unknown',
        key: item.productId + '-' + (item.title || 'Unknown')
      }
    };

    fetch(WEBHOOK, {
      method: 'POST',
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function handleLegacyHeartToggle(event) {
    var checkbox = event.target.closest('.zoomycheck');
    if (!checkbox) return false;

    var source = checkbox.closest('.zoomywishid');
    var item = getProductData(source);
    if (!item) return true;

    toggleItem(item);
    return true;
  }

  function handleDocumentClick(event) {
    var openButton = event.target.closest('[data-pk-wishlist-open]');
    if (openButton) {
      event.preventDefault();
      window.location.href = rewritePreviewHref(openButton.dataset.pkWishlistOpen);
      return;
    }

    var button = event.target.closest('[data-pk-wishlist-button]');
    if (button) {
      event.preventDefault();
      var item = getProductData(button);
      if (!item) return;
      toggleItem(item);
      return;
    }

    var removeButton = event.target.closest('[data-pk-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      removeItem(removeButton.dataset.pkWishlistRemove || removeButton.value);
      return;
    }

    var continueButton = event.target.closest('[data-pk-wishlist-continue]');
    if (continueButton) {
      event.preventDefault();
      window.location.href = rewritePreviewHref('https://purebredkitties.com/collections/kittens-for-sale');
    }
  }

  function observeNewNodes() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          syncPreviewOriginLinks(node);
          renderLegacyHearts(node);
          syncButtons(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    ensureFontAwesome();
    ensureLegacyClasses();
    syncPreviewOriginLinks();
    renderLegacyHearts();
    syncButtons();
    renderWishlistPage();
    updateCounters(getItems().length);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('change', handleLegacyHeartToggle);
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) {
        renderLegacyHearts();
        syncButtons();
        renderWishlistPage();
        updateCounters(getItems().length);
      }
    });
    observeNewNodes();
  }

  window.pkWishlist = {
    getItems: getItems,
    hasItem: hasItem,
    getItemById: getItemById,
    addItem: addItem,
    removeItem: removeItem,
    toggleItem: toggleItem,
    syncButtons: syncButtons,
    renderWishlistPage: renderWishlistPage,
    updateCounters: updateCounters,
    renderLegacyHearts: renderLegacyHearts
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
